import { render, staticRenderFns } from "./scheda.vue?vue&type=template&id=09f1394e"
import script from "./scheda.vue?vue&type=script&lang=js"
export * from "./scheda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports